import PrimaryPlacement from "./PrimaryPlacement";
export default PrimaryPlacement;
